export const environment = {
  production: true,
  baseUrl: 'https://www.stok.gencdepolama.com/api'
};
